module.exports = __webpack_public_path__ + "static/media/tech_and_software.a06be594.png";